module.exports = __webpack_public_path__ + "img/Rabih Mroué.49cff32f.jpg";